import ko from 'knockout';
Object.assign(window, { ko });
